import { render, staticRenderFns } from "./SubscribeTestimonialsItemKo.vue?vue&type=template&id=07a780fc&scoped=true&"
import script from "./SubscribeTestimonialsItemKo.vue?vue&type=script&lang=js&"
export * from "./SubscribeTestimonialsItemKo.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeTestimonialsItemKo.vue?vue&type=style&index=0&id=07a780fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a780fc",
  null
  
)

export default component.exports